<div class="bp-modal mod-lg">
  <bp-modal-header [cssStyle]="'mod-details'" [title]="'wallet_title' | translate">
    <a right (click)="close()" class="large-weight" (keydown.enter)="close()" [tabIndex]="0">
      {{ "close" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section">
      <span class="bp-modal-body-section-default">
        @if (data.wallet.isDefault()) {
          <span>
            <span class="bpi__icon-star-solid mod-account"></span>
            <span class="text-gray">{{ "default_crypto_wallet" | translate: [getTradableSymbol()] }}</span>
          </span>
        }
      </span>
      <bp-input
        class="bp-modal-body-section-input-info"
        type="text"
        [label]="'add_wallet_name' | translate"
        [(model)]="data.wallet"
        [maxlength]="40"
        (valueChange)="data.wallet.dirty = true"
        [placeholder]="'wallet_name' | translate"
        [field]="'name'"
        [error]="data.wallet.getValidationError('name') | translate"
        (onKeyEnter)="saveWallet()">
        <span>{{ "wallet_name_info" | translate }}</span>
      </bp-input>
      <div class="bp-modal-body-section-button">
        @if (!data.wallet.isDefault()) {
          <button class="btn btn-primary delete" (click)="deleteWallet()">
            {{ "delete_wallet" | translate }}
          </button>
        }
        <loading-button
          class="details-custom-button"
          right
          [disabled]="!data.wallet.dirty"
          [text]="'save' | translate"
        (onClick)="saveWallet()"></loading-button>
      </div>
    </div>
  </div>
</div>
